import Vue from 'vue'
import { setUserInfo, setToken } from './auth'
import https from './http'

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
 export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 对象深拷贝
 * @param {*} key
 */
export function objDeepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}
// 格式化日期
export function dateFormate(date, fmt) {
  if (!date) {
    return ''
  }
  date = new Date(date)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

/**
 * @param {*} unit 传空-默认格式返回yyyy-MM-dd HH-mm-ss， ‘cn’:年月日 （‘-’，‘.’）…
 * @param {*} date 时间戳，或者传空默认获取当天
 * @param {*} isNeedHms 是否需要时分秒 true需要 false不需要
 */
export function getDate(unit, date, isNeedHms) {
  var d = null;
  if (date) {
    d = new Date(date);
  } else {
    d = new Date();
  }
  var year = d.getFullYear();//得到年
  var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);//得到月
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();//得到日
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();//得到时
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();//得到分
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();//得到秒
  if (!isNeedHms) {
    if (unit == 'cn') {
      return `${year}年${month}月${day}日`;
    } else {
      return [year, month, day].join("-");//格式为：YY-MM-DD hh:mm:ss（当前时间）
    }
  } else {
    if (unit == 'cn') {
      return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
    } else {
      return [year, month, day].join("-") + " " + [hour, minute, second].join(':');//格式为：YY-MM-DD hh:mm:ss（当前时间）
    }
  }
}

/**
 * @param {*} unit 传空-默认格式返回yyyy-MM-dd HH-mm-ss， ‘cn’:年月日 （‘-’，‘.’）…
 * @param {*} date 时间戳，或者传空默认获取当天
 * @param {*} isNeedHms 是否需要时分秒 true需要 false不需要
 */
export function getHms(unit, date, isNeeds) {
  var d = null;
  if (date) {
    d = new Date(date);
  } else {
    d = new Date();
  }
  var year = d.getFullYear();//得到年
  var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);//得到月
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();//得到日
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();//得到时
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();//得到分
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();//得到秒
  if (!isNeeds) {
    if (unit == 'cn') {
      return `${year}年${month}月${day}日`;
    } else {
      // return [year, month, day].join("-");//格式为：YY-MM-DD hh:mm:ss（当前时间）
      return hour + ":" + minute;
    }
  } else {
    if (unit == 'cn') {
      return `${year}年${month}月${day}日 ${hour}时:${minute}:${second}`;
    } else {
      // return [year, month, day].join(unit) + " " + [hour, minute, second].join(':');//格式为：YY-MM-DD hh:mm:ss（当前时间）
      return [hour, minute, second].join(':');
    }
  }
}
/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete('token')
  store.commit('resetStore')
  localStorage.clear()
  router.options.isAddDynamicMenuRoutes = false
}

/**
 *密码加密
 */
export function cryptPwd(text) {
  if (!text || text.length <= 0) {
    return ''
  }
  return crypto.MD5(text).toString()
}

// 登录统一处理
export function loginFn(data, that) {
  const { token } = data
  setToken(token)
  that.$https({
    url: that.$https.adornUrl('/admin/sys/user/info'),
    method: 'GET'
  }).then(({ data }) => {
    if (data.code !== 0) {
      that.$message.error(data.message)
      return false
    }
    setUserInfo(data.data)
  }).catch(err => {
    that.$message.error(err)
  }).finally(() => {
    // 登陆后跳转首页
    that.$router.push(`/sys-welcome`)
  })
}

// 处理区域code
export function hanldeCode(data) {
  if (!data || data.length !== 6) {
    return false
  }
  const code = data.toString()
  const provinceCode = `${code.substr(0, 2)}0000`
  const cityCode = `${code.substr(0, 4)}00`
  return { province: provinceCode, city: cityCode, area: code }
}


// 生成表格对应的键值
export function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}

// 处理空格
const blankSpaceReg = /(^\s*)|(\s*$)/g
export function handleBlankSpace(path) {
  return path.replace(blankSpaceReg, '')
}

// 获取url参数
export function getUrlKey(name, url) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}


/**
 * 获取身份证其他信息
 * @param {*} len 身份证号码长度
 * @param {*} idCardNo 身份证号码
 */
export function getIdCardInfo(len, idCardNo) {
  let iden = idCardNo;
  let sex = null;
  let birth = null;
  let myDate = new Date();
  let month = myDate.getMonth() + 1;
  let day = myDate.getDate();
  let age = 0;
  const _AREA = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江",
    31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北",
    43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏",
    61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
  };

  if (len === 18) {
    age = myDate.getFullYear() - iden.substring(6, 10) - 1;
    sex = iden.substring(16, 17);
    birth = iden.substring(6, 10) + "-" + iden.substring(10, 12) + "-" + iden.substring(12, 14);
    if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

  }
  if (len === 15) {
    age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
    sex = iden.substring(13, 14);
    birth = "19" + iden.substring(6, 8) + "-" + iden.substring(8, 10) + "-" + iden.substring(10, 12);
    if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
  }
  sex = sex % 2 === 0 ? '女' : '男';
  return {
    sex: sex,
    age: age,
    birthday: birth,
    birthplace: _AREA[iden.substring(0, 2)],
  }
}
/**
 * 获取两位小数点
 * @param {*} val 数值
 * @param {Number} num 小数点
 */
export function getTofixed(val, num) {
  return parseFloat(val).toFixed(num);
}
/**
 * 控制输入框只能输入数字和小数点
 * @param {*} val 数值
 */
export function resDecPoint(val) {
  // eslint-disable-next-line no-useless-escape
  val = val.replace(/[^\d.]/g, "") //清除非 数字和小数点的字符
  val = val.replace(/\.{2,}/g, ".") //清除第二个小数点
  val = val.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
  val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  // eslint-disable-next-line no-useless-escape
  val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //保留两位小数
  // this.info[name] = this.info[name].indexOf(".") > 0? this.info[name].split(".")[0].substring(0, 7) + "." + this.info[name].split(".")[1]: this.info[name].substring(0, 7); //限制只能输入7位正整数
  return val
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || 0
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  //循环所有项
  const treeData = cloneData.filter(father => {
    let branchArr = cloneData.filter(child => {
      //返回每一项的子级数组
      return father[id] === child[parentId]
    });
    branchArr.length > 0 ? father.children = branchArr : '';
    //返回第一层
    return father[parentId] === rootId;
  });
  return treeData != '' ? treeData : data;
}

//  获取字典
export function getDicts(dictCode, cb) {
  https.get('system/dict/data/type/' + dictCode, {}).then(res => {
    // return res.data;
    cb && cb(res.data);
  }).catch(res => {
    console.log(res)
    // this.$message.error((res && res.data && res.data.msg) || '接口请求异常');
  })
}
// 获取当天、前一天的日期
export function fun_date(num) {
  var date1 = new Date();
  //今天时间
  var time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate()
  console.log(time1);
  var date2 = new Date(date1);
  date2.setDate(date1.getDate() + num);
  //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
  var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
  console.log(time2);
  return time2;
}

/**
 * 近一个月日期范围（按自然月：结束日往前推一个月）
 * @param {'date'|'datetime'} fmt date → yyyy-MM-dd；datetime → yyyy-MM-dd HH:mm:ss
 * @returns {[string, string]}
 */
export function getRecentMonthRange(fmt = 'date') {
  const end = new Date();
  const start = new Date(end.getFullYear(), end.getMonth() - 1, end.getDate());
  const pad = (n) => (n < 10 ? '0' + n : '' + n);
  const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  if (fmt === 'datetime') {
    return [`${ymd(start)} 00:00:00`, `${ymd(end)} 23:59:59`];
  }
  return [ymd(start), ymd(end)];
}
// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].dictValue == ('' + value)) {
      actions.push(datas[key].dictLabel);
      return true;
    }
  })
  return actions.join('');
}
/**
 * 获取药企信息
 * @param {String} key 
 */
export function getEnterpriseInfo(key) {
  const info = JSON.parse(localStorage.getItem('enterpriseInfo'))
  console.log({info});
  return info[key]
}